module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball4-f37dd7ed44601a6098b04a5a85f58369.png";